
import React from 'react';
import Icon404 from "components/Error404/Icon404";
import style from './style.scss'; //NOSONAR

const PlpEmpty = () => {

    return(
        <div className="shelf-empty-wrap">
            <Icon404 />
            <h4 className="shelf-empty-stock-title">
            Lo sentimos, en este momento no tenemos stock en esta categoría. 
            </h4>
            <h5 className="shelf-empty-stock-subtitle">
            Estamos trabajando para tener productos cargados prontamente.
            </h5>
        </div>
    )

}


export default PlpEmpty;
